import { EnvironmentType } from "./EnvironmentType";

export class EnvironmentManager {

    public static getCurrentEnv(): EnvironmentType {
        let castedEnv = process.env.REACT_APP_ENV as EnvironmentType
        if (castedEnv)
            return castedEnv
        return EnvironmentType.staging
    }

    public static isProdEnv(): boolean {
        return EnvironmentManager.getCurrentEnv() === EnvironmentType.production
    }

    public static isStagingEnv(): boolean {
        return EnvironmentManager.getCurrentEnv() === EnvironmentType.staging
    }

    public static isLocalEnv(): boolean {
        return EnvironmentManager.getCurrentEnv() === EnvironmentType.development
    }

}